import styled from "styled-components";
import { SecondaryMenu } from "../../../../services/visualLibraryService";
import { i18n } from "../../../../services/i18nService";

export const BlockStyled = styled.div`
  & {
    ${props => (props.isTabExits ? "width: 78%" : "width: 100%")};
  }
`;

export const BlockStyledTabs = styled.div`
  & nav ul li {
    font-size: 1.6rem;
    font-weight: 600;
  }
`;

export const SecondaryMenuStyled = styled(SecondaryMenu)`
  &&& {
    left: auto;
    right: 0;
    overflow: hidden;
    height: 24rem;
  }
  ${props =>
    `${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left"}: -${props.theme.spacing.xsmall}`};
  li {
    border: 2px solid rgba(255, 255, 255, 0);
    border-radius: 1.421rem;
  }
  li.selected {
     background: ${props => props.theme.color.secondary};
    // border: 2px solid ${props => props.theme.color.grey};
  }
  li.focused {
    background: ${props => props.theme.color.primary};
    border: 2px solid ${props => props.theme.color.primary};
  }
  nav {
    left: auto;
    right: 0;
  }
`;

export const EpgCategoriesWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  &::after {
    content: "";
    flex: 1 1 auto;
    height: 2px;
    display: inline-block;
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

export const CategoriesIconStyled = styled.object`
  display: flex;
  align-items: center;
`;
export const CategoriesLineStyled = styled.div``;
export const CategoriesLabelStyled = styled.h2`
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  margin: 0rem 0.8rem;
`;
